<div class="page__404">
  <div class="main--wrapper">
    <header>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="auth-section--logo">
              <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'" 
              onerror="this.src='assets/images/logo.png';" alt="Logo">
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container">
      <div class="auth-box--wrapper position-relative">
        <div class="blueish-bg">
          <div class="shade upper"></div>
          <div class="shade lower"></div>
        </div>

        <div class="box-wrapper">
          <div class="auth-box--title">Page not found</div>
          <div class="auth-box--description">Sorry the page was not found. Please go back to the home page and start again.</div>

          <div class="text-center mt-50">
            <svg-icon name="404_page"></svg-icon>

            <div class="mt-50">
              <a role="button" href="/"
                      class="button primary__button large__button px-5">
                Go Home
              </a>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
